import React, { useEffect, useState } from 'react';
import { useClient } from 'shared';
import type { TProviderRecentlyWorked } from '../../home/new/types';
import { Modal } from 'library/ui';
import { IProviderReviewOption } from 'models';
import ProviderReviewModalList from './ProviderReviewModalList';

const SESSION_STORAGE_KEY = 'provider-review-modal-seen';

export default function ProviderReviewModal({
    workers,
    open,
    onCloseModal,
}: {
    workers?: TProviderRecentlyWorked[];
    open?: boolean;
    onCloseModal?: () => void;
}) {
    const { data: options } = useClient<IProviderReviewOption[]>({ url: 'api/provider-review-options/' });

    const hasUnreviewedWorkers = !!workers && workers.length > 0;
    const seenModal = sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';

    const [isOpen, setOpen] = useState(hasUnreviewedWorkers && !seenModal);

    useEffect(() => {
        if (hasUnreviewedWorkers && !seenModal) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [hasUnreviewedWorkers, seenModal]);

    const onClose = () => {
        setOpen(false);
        sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
        onCloseModal?.();
    };

    if (!(isOpen || !!open)) {
        return null;
    }

    return (
        <Modal title="Review Your Workers" onClose={onClose} width={760} maxHeight="85vh">
            {workers && options && <ProviderReviewModalList workers={workers} options={options} />}
        </Modal>
    );
}
